import React, {Fragment, useContext, useEffect} from 'react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../App/stores/RootStore'
import Moment from "react-moment";
import moment from 'moment';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import {Button, ButtonGroup, Card, Checkbox, Divider, Grid, Icon, Label, List, ListItem} from "semantic-ui-react";
//TODO: pull this data from the API
function convertDataElementCodeToText (stringCode:string|undefined):string {
    if (stringCode == undefined){
        return "err"
    }
    const code = parseInt(stringCode)
    if (code == 0){
        return "No Risk Code"
    }
    else if(code == 1){
        return "Name"
    }
    else if(code == 2){
        return "Name, Address"
    }
    else if(code == 3){
        return "Name, DOB"
    }
    else if(code == 4){
        return "Name, Address, DOB"
    }
    else{
        return "err"
    }

}
const RequestReviewDocuments: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { RequestReview } = rootStore.requestReviewStore;
    const { requestPriorReviewSummary } = rootStore.priorReviewSummaryStore;
    const { updateRequestToSpanish } = rootStore.requestStore;

    useEffect(() => {
        localStorage.setItem("requestId", RequestReview?.requestId!)
        localStorage.setItem("requestCaseId", String(RequestReview?.requestCaseID))
    })

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header>
                    <Label> Case ID: {RequestReview?.requestCaseID} </Label>
                    <Label> Provider ID: {RequestReview?.provider} </Label>
                    <Label> Registration Request ID: {RequestReview?.registrationRequestID} </Label>
                    <Button className={'rl-btn pdf-link-btn'} floated={"right"} style={{ padding: '3px' }}>
                        <a href={window.location.protocol + '//' + window.location.host + '/RequestReviewPDF'}
                            target="_blank" className={'pdf-link'}>
                            <Icon name="file pdf outline" />Open PDF
                        </a>
                    </Button>
                </Card.Header>
                <Card.Header textAlign={"left"}>
                    <Checkbox onClick={(e, { checked }) => RequestReview!.reviewEnd === null ? updateRequestToSpanish(RequestReview?.requestId!, checked!) : ""}
                              toggle checked={RequestReview?.spanishRequest}
                              label='Is a Spanish Request' />
                    {requestPriorReviewSummary.map(([group, requestPriorReviewSummaries]) => (
                        <Fragment key={group}>
                            {requestPriorReviewSummaries.map(requestPriorReviewSummary => (
                                <Label>Previous Review Result - {requestPriorReviewSummary.recommendation}</Label>
                            ))}
                        </Fragment>
                    ))}

                </Card.Header>

            </Card.Content>
        </Card>
    )
}
export default observer(RequestReviewDocuments);